import { useContext, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useGetUserShareLinkSearchCriteriaQuery } from '../../models/GQLGeneratedModels';
import { ApplicationContext } from '../ApplicationProvider';
import { ConfigitContext } from '../ConfigitProvider';
import { Loading } from '../shared/Loading/Loading';
import { jsx as _jsx } from "react/jsx-runtime";
var LoadShareSearch = function (props) {
    var _a = useContext(ApplicationContext), setItemOffset = _a.setItemOffset, setItemsPerPage = _a.setItemsPerPage;
    var _b = useContext(ConfigitContext), setManufacturerProduct = _b.setManufacturerProduct, updateConfigitCriteria = _b.updateConfigitCriteria, layerConfigMasterData = _b.layerConfigMasterData, sections = _b.sections;
    var params = useParams();
    if (!params.ShareLinkGuid) {
        throw Error('Empty ShareLinkGuid');
    }
    var _c = useGetUserShareLinkSearchCriteriaQuery({ variables: { ShareLinkGuid: params.ShareLinkGuid } }), data = _c.data, error = _c.error, loading = _c.loading;
    useEffect(function () {
        if (data && layerConfigMasterData !== null && layerConfigMasterData !== void 0 && layerConfigMasterData.length && sections.length) {
            var configitCriteriaString = atob(data.UserShareLink[0].SearchCriteriaData);
            var configitCriteria = JSON.parse(configitCriteriaString);
            if (configitCriteria.manufacturerProduct.length)
                setManufacturerProduct(configitCriteria.manufacturerProduct);
            else {
                updateConfigitCriteria(configitCriteria.variableAssignments, configitCriteria.layers, configitCriteria.excludedLayerIds);
            }
        }
    }, [data, layerConfigMasterData, !sections.length]); // !sections.length should only trigger this effect when sections is undefined and populated not everytime it changes
    return /*#__PURE__*/ _jsx("div", { className: "d-flex justify-content-center align-items-center loading-spinner-full", children: /*#__PURE__*/ _jsx(Loading, {}) });
};
export default LoadShareSearch;
